import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import classes from './styles.module.css';

class EmptyCard extends PureComponent {
    render() {
        return (
            <div className={classes.Card}>
                {this.props.title && (
                    <div className={classes.Title}>
                        <h5>
                            <FormattedMessage id={this.props.title} defaultMessage={this.props.title} />
                            {this.props.subtitle && <span>{this.props.subtitle}</span>}
                        </h5>
                    </div>
                )}

                <div className={classes.Body}>{this.props.children}</div>
            </div>
        );
    }
}

export default EmptyCard;



// WEBPACK FOOTER //
// ./src/hoc/EmptyCard/index.js